import { computed } from "vue";
import { useInvitationsStore, wireInvitations } from "@/shared/stores/invitationsStore";

/**
 * The signed-in user's invitations inbox, for everything that shows it: the Account section's list,
 * the badge and "Invitations (N)" row of the user menus, and the banners of the two home pages.
 *
 * Calling this reads nothing by itself: the store is wired once per app (`wireInvitations`), reads
 * the inbox when somebody signs in and keeps it current from the user's room — see
 * `shared/stores/invitationsStore.ts`. Every caller shares that one list, so the badge on the avatar
 * and the list it leads to cannot disagree.
 */
export function useInvitations() {
	const store = useInvitationsStore();
	wireInvitations(store);

	return {
		/** Pending invitations, newest first. */
		invitations: computed(() => store.invitations),
		/** How many are pending; zero while the provider has not verified the email. */
		count: computed(() => store.count),
		/** `null` until the inbox has been read. */
		emailVerified: computed(() => store.emailVerified),
		loaded: computed(() => store.loaded),
		loading: computed(() => store.loading),
		error: computed(() => store.error),
		/** The home pages' banner is showing: there are pending invitations it was not dismissed for. */
		bannerVisible: computed(() => store.bannerVisible),
		dismissBanner: store.dismissBanner,
		reload: store.reload,
		accept: store.accept,
		decline: store.decline,
	};
}
